<template>
<div>
  	<!-- page wrapper start -->
	<div class="pg-wrapper">
    <app-header>
      <div class="title-bar" slot="header-foot">
				<button @click="goBack()" class="button is-flex nav-back">
					<img src="@/assets/img/icon-nav-arrow-left.svg" alt="Go Back">
				</button>
		  		<h1 class="title">Notifications</h1>
			</div>
    </app-header>

   <main class="content-wrapper has-background-white-bis pb0">
			<div class="columns mv0 flex-grow-1 is-marginless">
				<!-- TABS -->
				<div class="column flex-grow-0 has-background-white">
					<ul class="columns is-multiline tabs has-arrow-mobile notification-tabs">
						<li :class="notification.is_active ? 'is-active column is-12' : 'column is-12'"  v-bind:key="'tab_'+index" v-for="(notification, index) in notifications">
							<a v-on:click="setActiveTab(index)">
                <span class="alert-notification" v-if="!notification.read_at">!</span>
								<span class="tab-label" v-html="notification.title"></span>
							</a>
						</li>
					</ul>
				</div>

				<!-- Search Results Content -->
        <template v-for="(notification, index) in notifications">
          <div class="column flex-grow-1 section-search-results selected-tab-content" v-bind:key="'content_'+index" v-if="notification.is_active">
            <div class="content"  v-html="notification.content" >
            </div>
          </div>
        </template>
			</div>
		</main>

    <app-footer></app-footer>
	</div>
</div>
</template>
<script>
import Env from '@/env';
import { mapGetters, mapActions } from "vuex";

export default {
  name: 'UserNotifications', // Not used only for future 
  data() {
    return {

    };
  },
  mounted() {
    const self = this;
    this.fetchNotifications();
    // fetch in every 3 seconds // Or use socketio
    // setInterval(function(){ self.fetchNotifications(); }, 3000);
  },
  computed: {
    ...mapGetters({
      notifications: "usernotifications/list",
    })
  },

  methods: {
    /**
     * Set active Tab
     */
    setActiveTab(index) {
      this.notifications.map(item => {
        item.is_active = false;
      })
      this.notifications[index].is_active = true;
      // Make this notification seen
      this.markNotificationSeen(this.notifications[index])
    },
    /**
     * Mark notification seen
     */

    markNotificationSeen(item){
      const url = `${Env.notificationUrl}/notification/markAsReadNotification`;
      this.postApi(url,{
        "app-token":`bearer ${Env.notificationToken}`,
      },{
        "user_alias": this.$store.getters.getLoggedInUserId,  
      })
      .then( res => {
     
      })
      .catch( err => {
       
      })
    },

    /**
     * Fetch notifications
     */
    fetchNotifications() {
      const url = `${Env.notificationUrl}/notification`;
      this.postApi(url,{
        "app-token":`bearer ${Env.notificationToken}`,
      }, {
        "user_alias": this.$store.getters.getLoggedInUserId,
        "noofrecord": 10,
        "start": 1,
        "notification_type": "push"
    })
      .then( res => {
        let notifications = [];
        res.data.payload.notificationData.map( (item, index) => {
          let notificationObj = JSON.parse(item.notification_request);
          notifications.push({
            title: notificationObj.notification.title,
            content: notificationObj.notification.body,
            is_active: index == 0 ? true : false,
            read_at: item.read_at,
            notification_id: item.notification_id
          })
        })
        this.va_setUserNotifications(notifications)
      })
      .catch( err => {
        console.log('Unable to fetch user notifications.')
      })
    },

    goBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push({ name: 'HomePage' });
    },

    ...mapActions({
      va_setUserNotifications: "usernotifications/setList",
    })

  },
};
</script>
<style scoped>
span.tab-label {
  max-width: 204px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
span.alert-notification {
    position: absolute;
    width: 20px;
    height: 20px;
    background: #d40000;
    right: 0;
    top: 5px;
    color: #fff;
    text-align: center;
    border-radius: 50%;
}
</style>

